"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'You can pass a label inside Checkbox body.';
var code = "import React from 'react';\nimport { Checkbox } from 'jsc-react-ui';\n\nconst CheckboxExample = () => <Checkbox>Cinema</Checkbox>";
exports.LabelExampleCheckbox = function () { return (React.createElement(common_1.Example, { title: "Label", description: description, code: code },
    React.createElement(components_1.Checkbox, null, "Cinema"))); };
exports.LabelExampleCheckbox.displayName = 'LabelExampleCheckbox';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/LabelExampleCheckbox.tsx
// module id = 649
// module chunks = 0